/* globals Class,lp */
;(function(){
  var _roundNumber = function(number, decimalPlaces) {
    return Math.round(parseFloat(number) * Math.pow(10, decimalPlaces)) /
      Math.pow(10, decimalPlaces);
  };

  lp.editor.TextTransformBoxHandleHelper = Class.create(lp.editor.TransformBoxHandleHelper, {
    handleDragTop: null,
    handleDragBottom: null,
    initialize: function($super, box, elm) {
      $super(box, elm);

      // wire up the scaling drag handlers:
      var self = this;

      this._updateModelAfterDragTopLeft = this._mkDragHandler(function(args) {
        self.model.setScale(args.scale);
        self.model.setOffset({
          left: self.elmStartOffset.left - args.xDelta,
          top: self.elmStartOffset.top - args.yDelta
        });
      });

      this._updateModelAfterDragBottomRight = this._mkDragHandler(function(args) {
        self.model.setScale(args.scale);
      });

      this._updateModelAfterDragTopRight = this._mkDragHandler(function(args){
        self.model.setScale(args.scale);
        self.model.setTop(self.elmStartOffset.top - args.yDelta);
      });

      this._updateModelAfterDragBottomLeft = this._mkDragHandler(function(args){
        self.model.setScale(args.scale);
        self.model.setLeft(self.elmStartOffset.left - args.xDelta);
      });
    },

    _maintainAR: function() {
      return true;
    },

    _mkDragHandler: function(cback) {
      return function (args) {
        var scale0 = _roundNumber(args.width / this.elmStartSize.width, 2);
        // we need to normalize the scale in case it was initially something other than 1
        var scale = _roundNumber(scale0 * this.elmStartScale, 2);
        if (scale <= 1.5 && scale >= 0.5) {
          this.model.suppressEvents();
          var scaleDelta = scale - this.elmStartScale;
          var xDelta = Math.floor(scaleDelta * this.elmStartSize.width);
          var yDelta = Math.floor(scaleDelta * this.elmStartSize.height);
          cback({scale: scale, yDelta: yDelta, xDelta: xDelta});
          this.model.releaseEvents();
        }
      };
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/text_transform_box_handle_helper.js
// module id = 1035
// module chunks = 0